import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	confirmReopenJsmFormNoticeTitle: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-reopen-form-with-indexitem.confirm-reopen-jsm-form-notice-title',
		defaultMessage: 'Open customer edits on this form',
		description:
			'The title of the confirmation modal checking that the user wants to reopen the form for JSM.',
	},
	confirmReopenJsmFormNoticeBody: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-reopen-form-with-indexitem.confirm-reopen-jsm-form-notice-body',
		defaultMessage:
			'Customers will be able to edit and resubmit this form. Once submitted, customer edits will be closed.',
		description:
			'The content of the confirmation modal checking that the user wants to reopen the form for JSM.',
	},
	confirmReopenFormNoticeTitle: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-reopen-form-with-indexitem.confirm-reopen-form-notice-title',
		defaultMessage: 'Open edits on this form',
		description:
			'The title of the confirmation modal checking that the user wants to reopen the form.',
	},
	confirmReopenNonJsmFormNoticeBody: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-reopen-form-with-indexitem.confirm-reopen-non-jsm-form-notice-body',
		defaultMessage: 'Opening edits will allow you to submit changes to this form.',
		description:
			'The content of the confirmation modal checking that the user wants to reopen the form.',
	},
	noticeCloseLabel: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-reopen-form-with-indexitem.notice-close-label',
		defaultMessage: 'Cancel',
		description: 'The label for the close button on the notices.',
	},
	noticeConfirmLabel: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-reopen-form-with-indexitem.notice-confirm-label',
		defaultMessage: 'Open edits',
		description: 'The label for the confirm button on the notices.',
	},
});
